"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectTag = void 0;
const base_1 = require("./base");
class IkeObjectTag extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'Tag';
        this.actionName = 'tag';
        this.cacheKeys['uuid'] = true;
    }
}
exports.IkeObjectTag = IkeObjectTag;
//# sourceMappingURL=tag.object.js.map